/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const Icons19 = ({ color = "white", className }) => {
  return (
    <svg
      className={`icons-19 ${className}`}
      fill="none"
      height="25"
      viewBox="0 0 24 25"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="g" clipPath="url(#clip0_2608_2019)">
        <path
          className="path"
          d="M9.89902 4.90018C10.5874 4.73906 11.2921 4.65852 11.999 4.66018C18.999 4.66018 22.999 12.6602 22.999 12.6602C22.392 13.7958 21.6681 14.8649 20.839 15.8502M14.119 14.7802C13.8444 15.0749 13.5132 15.3113 13.1452 15.4753C12.7772 15.6393 12.3799 15.7274 11.9771 15.7345C11.5743 15.7417 11.1742 15.6676 10.8006 15.5167C10.4271 15.3658 10.0877 15.1412 9.80287 14.8563C9.51799 14.5715 9.29342 14.2321 9.14253 13.8586C8.99165 13.485 8.91755 13.0849 8.92466 12.6821C8.93176 12.2793 9.01993 11.882 9.1839 11.514C9.34787 11.146 9.58428 10.8148 9.87902 10.5402M17.939 18.6002C16.2296 19.9032 14.1481 20.625 11.999 20.6602C4.99902 20.6602 0.999023 12.6602 0.999023 12.6602C2.24291 10.3421 3.96816 8.31679 6.05902 6.72018L17.939 18.6002Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.99832"
        />

        <path
          className="path"
          d="M1 1.66016L23 23.6602"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.99832"
        />
      </g>

      <defs className="defs">
        <clipPath className="clip-path" id="clip0_2608_2019">
          <rect
            className="rect"
            fill="white"
            height="24"
            transform="translate(0 0.660156)"
            width="24"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

Icons19.propTypes = {
  color: PropTypes.string,
};
